import React from "react";
import { InputText } from "primereact/inputtext";
import { useField } from "formik";
import { MdInfoOutline } from 'react-icons/md';

const FormikInputField = ({
  placeholder = "",
  label = "",
  name = "",
  className = "",
  isIcon = false,
  icon,
  iconPos = "left",
  iconClassName = "",
  defaultValue = "",
  type = "text",
  NavigationIcon,
  onIconClick = () => { },
  parentClass = "",
  tooltipMessage = "",
  hideErrorText = false,
  unit = "",
  ...props
}) => {
  const [field, meta] = useField(name);

  const isInvalid = meta.error && meta.touched;

  const inputStyle = {
    ...props.style,
    fontWeight: unit ? '700' : 'normal'
  };

  return (
    <div className={`flex flex-col gap-1 w-full mb-1 ${parentClass}`}>
      {label && (
        <div className="flex items-center justify-between">
          <label
            htmlFor={name}
            className="input-label flex items-center gap-x-2"
          >
            {label}
            {unit && (
              <span className="text-xs text-gray-600 font-bold">
                ({unit})
              </span>
            )}
          </label>
          {NavigationIcon && (
            <NavigationIcon
              size={17}
              className="text-iconC cursor-pointer"
              onClick={onIconClick}
            />
          )}
        </div>
      )}

      <InputText
        id={name}
        placeholder={placeholder}
        type={type}
        autoComplete="off"
        {...(type === "number" ? { min: 0 } : {})}
        {...field}
        {...props}
        style={inputStyle}
        className={`input-field ${className} ${isInvalid && hideErrorText ? "!border-red-500" : ""}`}
      />
      {isInvalid && !hideErrorText && (
        <p className="text-sm text-red-500">{meta.error}</p>
      )}
    </div>
  );
};

// Standalone component
const StandaloneInputField = ({
  placeholder = "",
  label = "",
  name = "",
  className = "",
  iconClassName = "",
  value = "",
  type = "text",
  parentClass = "",
  tooltipMessage = "",
  handleChange = () => { },
  NavigationIcon,
  onIconClick = () => { },
  error = "",
  unit = "",
  ...props
}) => {
  const inputStyle = {
    ...props.style,
    fontWeight: unit ? '700' : 'normal'
  };

  return (
    <div className={`flex flex-col gap-1 w-full mb-1 ${parentClass}`}>
      {label && (
        <div className="flex items-center justify-between">
          <label htmlFor={name} className="input-label flex items-center gap-x-2">
            {label}
            {unit && (
              <span className="text-xs text-gray-600 font-bold">
                ({unit})
              </span>
            )}
          </label>
          {NavigationIcon && (
            <NavigationIcon
              size={17}
              className="text-iconC cursor-pointer"
              onClick={onIconClick}
            />
          )}
        </div>
      )}
      <InputText
        id={name}
        name={name}
        placeholder={placeholder}
        type={type}
        value={value}
        autoComplete="off"
        onChange={handleChange}
        {...(type === "number" ? { min: 0 } : {})}
        {...props}
        style={inputStyle}
        className={`input-field ${className} ${error ? "!border-red-500" : ""}`}
      />
      {error && (
        <p className="text-sm text-red-500">{error}</p>
      )}
    </div>
  );
};

// wrapper
const TextInput = (props) => {
  const { useFormik = true } = props;

  if (useFormik) {
    return <FormikInputField {...props} />;
  }

  return <StandaloneInputField {...props} />;
};

export default TextInput;
